/**
 * Model to hold ranking points
 */
import { IdentityRankingPointsEvent, IdentityRankingPointsSettings } from '@reg/shared/model';
import get from 'lodash-es/get';

export class IdentityRankingPoints {
    public id: string = null;
    public seasonId: string = null;
    public isDefault: boolean = null;
    public name: string = null;
    public settings: IdentityRankingPointsSettings = null;
    public events: IdentityRankingPointsEvent[] = [];

    public clone(): IdentityRankingPoints {
        const clone: IdentityRankingPoints = new IdentityRankingPoints();
        clone.id = this.id;
        clone.seasonId = this.seasonId;
        clone.name = this.name;
        clone.isDefault = this.isDefault;
        clone.settings = this.settings.clone();
        clone.events = this.events && this.events.map((e: IdentityRankingPointsEvent) => e.clone());

        return clone;
    }

    public serialize(): any {
        const json: any = {
            data: {
                type: 'rankingPoints',
                id: this.id,
                attributes: {
                    name: this.name,
                    isDefault: this.isDefault || false,
                    settings: this.settings ? this.settings.serialize() : null,
                },
                relationships: {
                    season: { data: { type: 'season', id: this.seasonId } },
                },
            },
        };

        return JSON.stringify(json);
    }

    public deserialize(json: any, included: any[]): IdentityRankingPoints {
        json = json.data || json;
        const attrs: any = json.attributes || {};
        included = included || [];

        this.id = json.id;
        this.name = attrs.name;
        this.seasonId = attrs.seasonId;
        this.isDefault = attrs.isDefault;

        if (attrs.settings) {
            this.settings = new IdentityRankingPointsSettings().deserialize(attrs.settings);
        }

        const eventList: any[] = get(json, 'relationships.events.data') || [];
        eventList.forEach((x: any) => {
            const item: any = included.find((i: any) => i.id === x.id);

            if (item) {
                this.events.push((new IdentityRankingPointsEvent()).deserialize(item));
            }
        });

        return this;
    }
}
